import { render, staticRenderFns } from "./MethodPaidAdd.vue?vue&type=template&id=d66c5658&scoped=true&"
import script from "./MethodPaidAdd.vue?vue&type=script&lang=js&"
export * from "./MethodPaidAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66c5658",
  null
  
)

export default component.exports